import React from 'react';
import _ from 'lodash';
import moment from 'moment';
import { enableTouch } from '../../../utilities/tabletUtil';
import { DropdownPortal } from './DropdownPortal';
import { ArrowDownIcon } from '../../icons/ArrowDownIcon';
moment.locale('ja');

/**
 * カレンダーのドロップダウン
 *
 * @export
 * @class DropDownCalenderPortal
 * @extends {React.Component}
 */
export class DropDownCalenderPortal extends React.Component {
  constructor(props) {
    super(props);

    this.today = moment();

    let value_date = null;
    value_date = moment(props.value, 'YYYY/MM/DD');
    if (!value_date.isValid()) {
      value_date = moment();
    }

    this.dropdownRef = React.createRef();
    this.decoratorRef = React.createRef();
    this.selectday = value_date.clone();
    this.selectFlg = false; // 選択フラグ

    this.state = {
      show: false,
      today: value_date.clone(),
      selectday: value_date.clone(),
      format: props.format ? props.format : 'YYYY/MM/DD',
      coords: {
        left: 0,
        top: 0,
      },
    };
  }

  componentWillReceiveProps(nextProps) {
    if (
      nextProps.value &&
      nextProps.value !== this.state.selectday.format('YYYY/MM/DD')
    ) {
      this.setState({
        today: moment(nextProps.value, 'YYYY/MM/DD'),
        selectday: moment(nextProps.value, 'YYYY/MM/DD'),
      });
    }
  }

  handleVisibleDropdownChange = newValue => {
    this.setState({ show: newValue });
    if (this.props.validate) {
      this.props.validate(this.props.name);
    }
    if (!_.isUndefined(this.props.DisplayText)) {
      let selectday = this.props.DisplayText();
      if (this.selectFlg === false && !selectday) {
        // 着工日,竣工予定日を選択していない場合
        this.props.onChange('');
      }
    }
  };

  todayAdd(n, type, _today) {
    _today = _today.clone().add(n, type);
    this.selectFlg = true;
    this.setState({ today: _today, selectday: _today });
    if (this.props.onChange) {
      this.props.onChange(_today.format('YYYY/MM/DD'));
    }
  }

  handleEvent() {
    return {
      selectDay: (...arg) => {
        let _today = this.state.today;
        _today.date(arg[1]);
        this.selectFlg = true;
        this.setState({
          today: _today,
          show: false,
        });
        if (this.props.onChange) {
          this.props.onChange(_today.format('YYYY/MM/DD'));
        }
        this.handleEvent().submit();
      },
      prevMonth: () => {
        this.todayAdd(-1, 'month', this.state.today);
      },
      nextMonth: () => {
        this.todayAdd(1, 'month', this.state.today);
      },
      submit: () => {
        // 選択時のバリデーション
        if (this.props.validate) {
          this.props.validate(this.props.name);
        }
      },
    };
  }

  generateDay() {
    let _today = this.state.today.clone();
    let days_num = _today.daysInMonth();
    const first = _today.date(1).format('D');
    const last = _today.date(days_num).format('D');
    let counter = 1;

    const Day = ({ day, select }) => {
      return (
        <td
          className='calender__day'
          onClick={e => {
            if (!enableTouch()) {
              this.handleEvent().selectDay(e, day);
            }
          }}
          onTouchEnd={e => {
            e.preventDefault();
            this.handleEvent().selectDay(e, day);
          }}
        >
          <span className={select ? 'calender-day selected' : 'calender-day'}>
            <div className='calender-day__number'>{day || '-'}</div>
          </span>
        </td>
      );
    };

    const weekdays = () => {
      let body = [];
      _.each([...Array(7)], (d, i) => {
        if (
          _today.date(counter).format('d') == i && //曜日
          counter >= first &&
          counter <= last
        ) {
          const selected = () => {
            if (
              this.state.selectday.format('D') == counter &&
              this.state.selectday.format('MM') == this.state.today.format('MM')
            ) {
              return true;
            }
            return false;
          };
          body.push(<Day key={i} day={_.clone(counter)} select={selected()} />);
          counter++;
        } else {
          body.push(<Day key={i} />);
        }
      });
      return body;
    };

    return _.map([...Array(6)], (v, i) => {
      return (
        <tr className='calender__week' key={i}>
          {weekdays()}
        </tr>
      );
    });
  }

  /**
   * カレンダーのコンポーネント
   *
   * @returns
   * @memberof DropDownCalenderPortal
   */
  Calender() {
    return (
      <div className='popup-calender'>
        <div className='popup-calender__header' />
        <div className='popup-calender__calender'>
          <div className='calender-header calender-header--popup-calender'>
            <div className='calender-header__prev-month'>
              <EnableTouchButton
                className='btn-icon'
                onClick={() => {
                  this.handleEvent().prevMonth();
                }}
              >
                <i className='i-arrow-left i-2x' />
              </EnableTouchButton>
            </div>
            <div className='calender-header__title'>
              {this.state.today.format('YYYY / MM')}
            </div>
            <div className='calender-header__next-month'>
              <EnableTouchButton
                className='btn-icon'
                onClick={() => {
                  this.handleEvent().nextMonth();
                }}
              >
                <i className='i-arrow-right i-2x' />
              </EnableTouchButton>
            </div>
          </div>
          <table className='calender calender--popup-calender'>
            <thead>
              <tr className='calender__label'>
                <th className='calender__day'>
                  <label htmlFor='sys-select-col-0' className='calender-label'>
                    <div className='calender-label__day'>日</div>
                  </label>
                </th>
                <th className='calender__day'>
                  <label htmlFor='sys-select-col-1' className='calender-label'>
                    <div className='calender-label__day'>月</div>
                  </label>
                </th>
                <th className='calender__day'>
                  <label htmlFor='sys-select-col-2' className='calender-label'>
                    <div className='calender-label__day'>火</div>
                  </label>
                </th>
                <th className='calender__day'>
                  <label htmlFor='sys-select-col-3' className='calender-label'>
                    <div className='calender-label__day'>水</div>
                  </label>
                </th>
                <th className='calender__day'>
                  <label htmlFor='sys-select-col-4' className='calender-label'>
                    <div className='calender-label__day'>木</div>
                  </label>
                </th>
                <th className='calender__day'>
                  <label htmlFor='sys-select-col-5' className='calender-label'>
                    <div className='calender-label__day'>金</div>
                  </label>
                </th>
                <th className='calender__day'>
                  <label htmlFor='sys-select-col-6' className='calender-label'>
                    <div className='calender-label__day'>土</div>
                  </label>
                </th>
              </tr>
            </thead>
            <tbody className='sys-calender-body'>{this.generateDay()}</tbody>
          </table>
        </div>
        <div className='popup-calender__footer' />
      </div>
    );
  }

  /**
   * @description 表示する文字列を指定
   */
  getDisplayValue() {
    if (!_.isUndefined(this.props.DisplayText) && _.isEmpty(this.props.value)) {
      return this.props.DisplayText();
    } else {
      return this.state.selectday.format(this.state.format);
    }
  }

  render() {
    const show = classname => {
      return this.state.show ? `${classname} show` : classname;
    };
    return (
      <div
        className={show('dropdown-calender')}
        style={this.props.style || null}
      >
        <div
          className='dropdown-calender__input'
          ref={this.decoratorRef}
          onClick={() => {
            this.setState(preState => ({ show: !preState.show }));
          }}
        >
          <input
            type='text'
            ref={this.props.name}
            value={_.defaultTo(this.getDisplayValue(), '')}
            readOnly
            disabled={this.props.disabled}
            id={this.props.name}
            className={this.props.disabled ? 'static' : ''}
            placeholder={this.props.placeholder}
            tabIndex={this.props.tabKeyStatus}
          />
          <ArrowDownIcon className='icon--2_4x form-list__arrow-icon' />
        </div>
        <DropdownPortal
          visible={this.state.show}
          decoratorRef={this.decoratorRef}
          dropdownRef={this.dropdownRef}
          onVisibleChange={this.handleVisibleDropdownChange}
        >
          <div
            className='dropdown-calender__calender drop-down-portal'
            ref={this.dropdownRef}
          >
            {this.Calender()}
          </div>
        </DropdownPortal>
      </div>
    );
  }
}

const EnableTouchButton = ({ className, style, onClick, children }) => (
  <button
    className={className}
    style={style}
    onClick={e => {
      e.preventDefault();
      if (!enableTouch()) {
        onClick(e);
      }
    }}
    onTouchEnd={e => {
      e.preventDefault();
      onClick(e);
    }}
  >
    {children}
  </button>
);



// WEBPACK FOOTER //
// ./src/components/dropdowns/portal/DropDownCalenderPortal.jsx